var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _path3, _path4, _path5, _rect14, _rect15, _path6, _rect16, _rect17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDokSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 270,
    viewBox: "0 0 262 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.457 52.7324L206.684 52.5048L206.684 258.228H0V7.39197e-06L153.856 3.33786e-06L206.457 52.7324Z",
    fill: "#E8E8E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 28.9927,
    width: 144.987,
    height: 3.86569,
    rx: 1.93284,
    fill: "#0067C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 55.2793,
    width: 107.198,
    height: 3.86569,
    rx: 1.93284,
    fill: "#0067C5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 42.136,
    width: 144.987,
    height: 3.86569,
    rx: 1.93284,
    fill: "#0067C5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 89.2974,
    width: 144.987,
    height: 3.86568,
    rx: 1.93284,
    fill: "#0067C5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 155.014,
    width: 107.198,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 102.441,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 115.584,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 128.727,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 141.871,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 189.032,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 228.462,
    width: 107.198,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 202.175,
    width: 144.987,
    height: 3.86569,
    rx: 1.93285,
    fill: "#0067C5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2083,
    y: 215.319,
    width: 144.987,
    height: 3.86568,
    rx: 1.93284,
    fill: "#0067C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.049 79.0623V52.0025H206.491L154.049 79.0623Z",
    fill: "url(#paint0_linear_8_679)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.856 0.22758L154.083 -8.42471e-06L206.684 52.7324L153.856 52.7324L153.856 0.22758Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.51 188.066C197.51 206.853 182.329 222.013 163.689 222.013C145.049 222.013 129.868 206.853 129.868 188.066C129.868 169.278 145.049 154.118 163.689 154.118C182.329 154.118 197.51 169.278 197.51 188.066Z",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 33
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.151 179.948C217.151 204.234 197.516 223.895 173.329 223.895C149.143 223.895 129.508 204.234 129.508 179.948C129.508 155.661 149.143 136.001 173.329 136.001C197.516 136.001 217.151 155.661 217.151 179.948Z",
    fill: "white",
    stroke: "#003453",
    strokeWidth: 13
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 133.034,
    y: 158.493,
    width: 53.599,
    height: 21.2613,
    fill: "#0067C5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 133.034,
    y: 189.032,
    width: 53.599,
    height: 21.2613,
    fill: "#0067C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.151 179.948C217.151 204.234 197.516 223.895 173.329 223.895C149.143 223.895 129.508 204.234 129.508 179.948C129.508 155.661 149.143 136.001 173.329 136.001C197.516 136.001 217.151 155.661 217.151 179.948Z",
    stroke: "#003453",
    strokeWidth: 13
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 22.0069,
    height: 11.1965,
    transform: "matrix(0.706223 0.707989 -0.706223 0.707989 205.337 206.041)",
    fill: "#003453"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 62.8321,
    height: 18.2761,
    rx: 9.13804,
    transform: "matrix(0.706223 0.707989 -0.706223 0.707989 217.626 212.576)",
    fill: "#003453"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_679",
    x1: 174.349,
    y1: 39.2553,
    x2: 170.501,
    y2: 79.4645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokSearchIcon);
export default __webpack_public_path__ + "static/media/dokSearchIcon.8816665eaca49437a797c5037110ddff.svg";
export { ForwardRef as ReactComponent };